import React, { createContext, useContext } from "react";

import defaultNavData from "./LayoutMenuData";

export type LayoutMenuDataComponent = () => React.ReactElement<{
  children?: React.ReactNode;
}>;

interface LayoutShellContextValue {
  navData: LayoutMenuDataComponent;
  homePath: string;
}

const defaultValue: LayoutShellContextValue = {
  navData: defaultNavData,
  homePath: "/",
};

const LayoutShellContext = createContext<LayoutShellContextValue>(defaultValue);

interface LayoutShellProviderProps {
  navData: LayoutMenuDataComponent;
  homePath?: string;
  children: React.ReactNode;
}

export const LayoutShellProvider = ({
  navData,
  homePath = "/",
  children,
}: LayoutShellProviderProps) => (
  <LayoutShellContext.Provider value={{ navData, homePath }}>
    {children}
  </LayoutShellContext.Provider>
);

export const useLayoutMenuData = (): LayoutMenuDataComponent =>
  useContext(LayoutShellContext).navData;

export const useLayoutHomePath = (): string =>
  useContext(LayoutShellContext).homePath;
